import { motion } from "framer-motion";
import { QrCode, SlidersHorizontal, Rocket, TrendingUp } from "lucide-react";

const steps = [
  {
    icon: QrCode,
    title: "Conecte.",
    desc: "Leia o QR Code do seu WhatsApp com o nosso painel. Em 30 segundos está online.",
    color: "text-warmz-green-bright",
    glow: "glow-green-sm",
  },
  {
    icon: SlidersHorizontal,
    title: "Configure.",
    desc: "Escolha um perfil de aquecimento, adicione contatos, selecione grupos e ative os stories automáticos.",
    color: "text-primary",
    glow: "glow-orange-sm",
  },
  {
    icon: Rocket,
    title: "Ative.",
    desc: "Ligue tudo com um clique. O robô conversa, publica stories e interage em grupos automaticamente.",
    color: "text-accent",
    glow: "glow-green-sm",
  },
  {
    icon: TrendingUp,
    title: "Evolua.",
    desc: "A esteira automática promove cada chip de Cold → Warm → Hot → Mature sem nenhuma intervenção.",
    color: "text-warmz-green-bright",
    glow: "glow-green-sm",
  },
];

const HowItWorks = () => (
  <section id="como-funciona" className="py-24">
    <div className="container mx-auto px-4 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground">
          Esqueça scripts complexos. É só apertar o <span className="gradient-text-fire">play.</span>
        </h2>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
            className="glass-card gradient-border p-8 text-center hover:bg-warmz-card-hover/40 transition-colors group"
          >
            <div className={`inline-flex items-center justify-center w-14 h-14 rounded-xl bg-secondary mb-6 ${s.glow}`}>
              <s.icon className={s.color} size={28} />
            </div>
            <span className="text-xs uppercase tracking-widest text-muted-foreground mb-2 block">
              Passo {i + 1}
            </span>
            <h3 className="font-display text-xl font-bold text-foreground mb-3">{s.title}</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
